import React, { useState, useEffect, useMemo } from "react";
import _, { get, cloneDeep, isEmpty } from "lodash";
import asyncRoute from '../../../../helpers/hoc/asyncRoute';
import Table from '../../../../components/CustomTable';
import { connect, useDispatch, useSelector } from "react-redux";
import { options, formFields, countryCodeConstant, countryLengthConstant, optionsForTable } from './constant';
import { withRouter, Link } from 'react-router-dom';
import ToastModal from "../../../../components/ToastModal";
import routes from '../../../../routes';
import ModalConfirmation from '../../../../components/ModalConfirmation';
import {
    handleFieldError,
    handleError,
} from "../../../../utils/form-validation";
import { checkPermission, checkTablePermission } from '../../../../utils/route-auth';
import { MODULE_PERMISSIONS, PERMISSION } from '../../../../constants/permission';
import placeholder from '../../../../assets/images/placeholder.webp';
import { encryptDataWithBlowfish, getDateFromUtcToSpecificZone, getTenantTimeZone, isApiCallSuccess, isTenantAdvertiser, isTenantAgency, isTenantDemoAdvertiser } from '../../../../selectors/index';
import {
    editTenantAction, getAllCurrencyAction,
    getProfileListAllAction,
    getSubscriptionCurrentAction,
    postBalanceValueAction,
    getCurrentMonthInvoiceListAction,
    addTenantAction,
    editAccountAction,
    addAccountAction,
    postAllTenantsFetchBalanceAction,
    getReSignInDataAction,
    dispatchPreSignInData,
    getUserProfileDetailsAction
} from "../../../../actions";
import DetailCard from "../DetailsCard";
import moment from "moment";
import { message } from "antd";
import { infoMessages } from "../../../../constants/demo/constant";


const Tabs = asyncRoute(() => import('../../../../components/Tabs'));
const Card = asyncRoute(() => import('../../../../components/Card'));
const Modal = asyncRoute(() => import('../../../../components/Modal'));
const BreadCrumb = asyncRoute(() => import('../../../../components/BreadCrumb'));
const Input = asyncRoute(() => import('../../../../components/FormElements/Input'));
const Spinner = asyncRoute(() => import('../../../../components/Spinner'));

function Account(props) {
    const [toastModal, setToastModal] = useState({
        enableToast: false,
        toastStatus: "",
        toastMsg: ""
    });
    const [modalConfirmation, setModalConfirmation] = useState({
        confirmationOpen: false,
        confirmationInfo: '',
    });

    const [tableItem, setTableItem] = useState({
        row: '',
        action: ''
    });

    const [searchParams, setSearchParams] = useState('');
    const [searchTimeout, setSearchTimeout] = useState(null);
    const [touched, setTouched] = useState({});
    const [errors, setErrors] = useState({});
    const [submited, setSubmited] = useState(false);
    const [form, setForm] = useState({});
    const [isEditMode, setIsEditMode] = useState(false);
    const [isSearchInputFocused, setIsSearchInputFocused] = useState(false);
    const [accountsList, setAccountList] = useState([]);
    const [tenantCurrency, setTenantCurrency] = useState({})
    const [tenantDetails, setTenantDetails] = useState({
        tenantName: '',
        contactEmail: '',
        contact: {
            address1: "",
            address2: "",
            country: "",
            city: "",
            state: "",
            pinCode: "",
            contactPhone: "",
            organizationTitle: "",
            gst: "-"
        },
        contactPerson: ''
    });

    const [advertiserDetails, setAdvertiserDetails] = useState({
        totalActiveCampaign: '',
        tentativeAmountDetail: 0,
    });

    const [currentBalance, setCurrentBalance] = useState(0);
    const [validityDate, setValidityDate] = useState('');
    const [optionsList, setOptionsList] = useState(optionsForTable);
    const [isTenantTypeAdvertiser, setIsTenantTypeAdvertiser] = useState(false);
    const [balanceAll, setBalanceAll] = useState([]);
    const [modalCallback, setModalCallback] = useState('');
    const tenantId = useSelector((state) => get(state, "app.preSignInState.tenantId", ""));
    const [isTenantAgencyType, setIsTenantAgencyType] = useState(isTenantAgency(tenantId));
    const [userProfileDetails, setUserProfileDetails] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    const userId = useSelector((state) => get(state, "app.preSignInData.userId", ""));
    const authToken = useSelector((state) => get(state, "app.signInData.authToken", ""));
    const parentTenantId = useSelector((state) => get(state, "app.preSignInState.parentTenantId", ""));
    const configurationList = useSelector((state) => get(state, "app.configurationData.responseList", ""));
    const rolesList = useSelector((state) => get(state, "app.adminRolesData.responseList", ""));
    const preSignInStateData = useSelector((state) => get(state, "app.preSignInState", ""));

    const targetTimeZone = getTenantTimeZone(tenantId);

    const modalType = {
        statusUpdated: 'statusUpdated'
    };

    const dispatch = useDispatch();

    const isDemoAdvertiser = useMemo(() => {
        return isTenantDemoAdvertiser(tenantId);
    }, [tenantId]);

    const toast = (status, msg) => {
        setToastModal({ enableToast: true, toastStatus: status, toastMsg: msg });
        return;
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        // console.log(name);
        // console.log(value);
        const newForm = { ...form };
        newForm[e.target.name] = value;
        if (name == 'search') {
            setSearchParams(value);
            setIsSearchInputFocused(true);
            return;
        }
        setForm(newForm);
    };

    const handleTouch = (e) => {
        const newTouched = { ...touched };
        const newErrors = { ...errors };
        const { error } = handleFieldError(e.target.value, formFields[e.target.name]);
        newErrors[e.target.name] = error;
        newTouched[e.target.name] = true;
        setTouched(newTouched);
        setErrors(newErrors);
    };

    const confirmationCallBack = (success, info) => {

    };

    const toggleModal = (confirmation) => {
        setModalConfirmation({
            confirmationOpen: !modalConfirmation.confirmationOpen,
            confirmationInfo: confirmation
        });
    };

    const handleToastStatus = async (status) => {
        setToastModal({
            ...toastModal,
            enableToast: status
        });
        if (modalCallback == modalType.statusUpdated) {
            await fetchProfileDetails();
        }
    };

    const confirmationCallbackModel = (id) => {
        setToastModal({
            ...toastModal,
            enableToast: false
        });
        if (toastModal.toastStatus == "save") {
            if (isDemoAdvertiser) {
                message.info(infoMessages.profileSave)
                return;
            }
            saveProfileDetails();
        }
        // if (!id) {
        //     submitForm(id);
        // }
        // if (method === "recActiveStatus") {
        //   handleStatusUpdate();
        // }
    };

    const reSignIn = async (data, authToken) => {
        await dispatch(getReSignInDataAction(data, authToken))
            .then((data) => {
                let { responseCode: { status = '' }, authToken = '' } = data;
                if (status === 'Success' && authToken) {
                    localStorage.setItem('redirectToConnection', true);
                    setTimeout(() => {
                        window.location.reload();
                    }, 500);
                }
            })
            .catch((error) => {
                console.error(error);
            });
    };

    const handleConnectionChange = async (row) => {
        try {
            const { history } = props;
            // console.log(event.target.name,"event")
            const preSignInData = JSON.parse(localStorage.getItem('PreSignInData'));
            const { responseList } = preSignInData;

            // console.log("preSignInData", preSignInData);

            const AuthData = JSON.parse(localStorage.getItem('AuthData'));
            const PreSignInState = JSON.parse(localStorage.getItem('PreSignInState'));
            const { authToken } = AuthData;

            const id = responseList.find(id => id.tenantId == row.advertiserId);
            if (id) {
                const tenantId = id.tenantId;
                localStorage.removeItem("editId");
                localStorage.removeItem("editAccountId");
                let obj = { ...preSignInStateData, tenantId }

                if (!isEmpty(preSignInStateData)) {
                    await dispatch(dispatchPreSignInData({ ...preSignInStateData, tenantId }))
                        .then(async () => {
                            let data = await encryptDataWithBlowfish({ ...preSignInStateData, tenantId });
                            await reSignIn(data, AuthData.authToken);
                            history.push(`/${routes.mainRoute}/${routes.containers.admin}/${routes.admin.connection.name}`);
                        })
                        .catch((error) => {
                            console.error(error);
                        });
                } else {
                    dispatch(dispatchPreSignInData({ ...PreSignInState, tenantId })).then(async () => {
                        let data = await encryptDataWithBlowfish({ ...PreSignInState, tenantId });
                        // reSignIn(data, authToken);
                        dispatch(getReSignInDataAction(data, authToken)).then(() => {
                            history.push(`/${routes.mainRoute}/${routes.containers.admin}/${routes.admin.connection.name}`);
                        });
                        // getReSignInDataAction({ ...PreSignInState, tenantId }, authToken);
                    });
                }
            } else {
                message.error(`You don't have access of ${row.advertiserName} advertiser.`);
            }
        } catch (e) {
            console.log(e);
        }
    }

    const handleAction = (row, action) => {
        const { match, history } = props;
        if (action.type === 'edit') {
            history.push(`${match.path}/${routes.admin.account.edit}`);
            localStorage.setItem('editAccountId', row.advertiserId);
        } else if (action.type === 'view') {
            history.push(`${match.path}/${routes.admin.account.view}/${row.advertiserId}`);
        } else if (action.type === 'recActive') {
            handleStatus(row, action);
        } else if (action.type === 'connection') {
            handleConnectionChange(row);
        }
    }

    const fetchTenantDetails = async () => {
        await dispatch(editTenantAction({ tenantId, authToken, userId, editId: tenantId, showLoader: false }))
            .then((data) => {
                const {
                    responseCode: { status = "" },
                    responseList,
                } = data;
                if (status === "Success" && responseList && responseList.length > 0) {
                    setTenantDetails(responseList[0]);
                    fetchCurrency(responseList);
                    setTenantDetailsInForm(responseList);
                } else {
                    console.log("Platform list not found");
                }
            })
            .catch((error) => {
                console.error(error);
                setIsLoading(false);
            });
    }

    const fetchCurrency = async (tenantResponseData) => {
        await dispatch(getAllCurrencyAction({ tenantId, authToken, userId, showLoader: false }))
            .then((data) => {
                const {
                    responseCode: { status = "" },
                    responseList,
                } = data;
                if (status === "Success" && responseList && responseList.length > 0) {
                    let displayCurrencyString = responseList.find((curr) => curr.key == tenantResponseData[0].currencyType)
                    setTenantCurrency(displayCurrencyString)
                } else {
                    console.log("Platform list not found");
                }
            })
            .catch((error) => {
                console.error(error);
                setIsLoading(false);
            });
    }

    const fetchAllAccountsBalance = async () => {
        let payload = { tenantId: tenantId };
        let params = { list: 'all' };
        await dispatch(postAllTenantsFetchBalanceAction({ tenantId, authToken, userId, params, payload, showLoader: false }))
            .then(async (data) => {
                const {
                    responseCode: { status = "" } = {},
                    response = []
                } = data;
                if (isApiCallSuccess(status)) {
                    // console.log(response, 'RESPONSE');
                    setBalanceAll(response);
                    await fetchProfileDetails(response);
                } else {
                    console.log("Balance list not found");
                }
            })
            .catch((error) => {
                console.error(error);
                setIsLoading(false);
            });
    }

    const fetchProfileDetails = async (balanceData) => {
        await dispatch(getProfileListAllAction({ tenantId, authToken, userId, showLoader: false }))
            .then((data) => {
                const {
                    responseCode: { status = "" },
                    response,
                } = data;
                // console.log(balanceAll,'balance2')
                if (status === "Success" && response && response.length > 0) {
                    let totalActiveCampaign = response.reduce((accumulator, currentValue) => {
                        return accumulator + currentValue.campaignCount
                    }, 0);
                    const mergedArray = response.map((data) => {
                        const matchingItem2 = balanceData && balanceData.find((item) => item.tenantId === data.advertiserId);
                        if (matchingItem2) {
                            // If a match is found, merge the data
                            return { ...data, ...matchingItem2 };
                        } else {
                            // If no match is found, return the original item from array1
                            return data;
                        }
                    });
                    setAccountList(mergedArray);
                    setAdvertiserDetails({ ...advertiserDetails, totalActiveCampaign });
                } else {
                    console.log("Platform list not found");
                }
            })
            .catch((error) => {
                console.error(error);
                setIsLoading(false);
            });
    }

    const fetchSubscriptionValidityDate = async () => {
        await dispatch(getSubscriptionCurrentAction({ tenantId, authToken, userId, showLoader: false }))
            .then((data) => {
                const {
                    responseCode: { status }, response
                } = data;
                if (status.toLowerCase() == "success") {
                    const validityDate = response && response.subscriptionDetails && response.subscriptionDetails.length && response.subscriptionDetails[0].endDate;
                    setValidityDate(validityDate);
                } else {
                    console.log("Platform list not found");
                }
            })
            .catch((error) => {
                console.error(error);
                setIsLoading(false);
            });
    }

    const fetchCurrentBalance = async () => {
        let payload = { tenantId: tenantId };
        await dispatch(postBalanceValueAction({ tenantId, authToken, userId, payload, showLoader: false }))
            .then((data) => {
                const { responseCode: { status = '' }, response } = data;
                if (response && response.balance) {
                    setCurrentBalance(response.balance);
                } else {
                    console.log("Balance not found!");
                }
            })
            .catch((error) => {
                console.error(error);
                setIsLoading(false);
            });
    };

    const fetchCurrentMonthDetails = async () => {
        await dispatch(getCurrentMonthInvoiceListAction({ tenantId, authToken, userId, showLoader: false }))
            .then((data) => {
                const { responseCode: { status }, response } = data;
                if (status.toLowerCase() == "success" && response && response.length > 0) {
                    setAdvertiserDetails({ ...advertiserDetails, tentativeAmountDetail: response[0].amount ? response[0].amount : 0 });
                } else {
                    console.log("Tentative Amount Details Not Found!");
                }
            })
            .catch((error) => {
                console.error(error);
                setIsLoading(false);
            });
    }

    const setTenantDetailsInForm = (responseList) => {
        const newForm = { ...form };
        newForm.organizationTitle = responseList[0].contact.organizationTitle
        newForm.contactPhone = responseList[0].contact.contactPhone
        newForm.country = responseList[0].contact.country
        newForm.currency = tenantCurrency && tenantCurrency.value
        newForm.gst = responseList[0].contact.gst
        newForm.address1 = responseList[0].contact.address1
        newForm.contactPerson = responseList[0].contactPerson
        newForm.contactEmail = responseList[0].contactEmail
        setForm(newForm);
    }

    const saveProfileDetails = async () => {
        const payload = {
            tenantId: tenantDetails.tenantId,
            tenantName: tenantDetails.tenantName,
            tenantType: `${tenantDetails.tenantTypeId}`,
            tenantTypeId: tenantDetails.tenantTypeId,
            contactEmail: form.contactEmail,
            contactPerson: form.contactPerson,
            contact: {
                address1: form.address1,
                address2: tenantDetails.address2,
                contactPhone: form.contactPhone,
                country: form.country,
                state: tenantDetails.state,
                city: tenantDetails.city,
                gst: form.gst,
                pincode: tenantDetails.pincode,
                organizationTitle: form.organizationTitle,
            },
            miscData: tenantDetails.miscData,
            currencyType: tenantDetails.currencyType,
            isActive: tenantDetails.isActive,
            user: tenantDetails.user
        }
        let addParams = { action: 'update' };
        await dispatch(addTenantAction({ tenantId, authToken, userId, payload, addParams }))
            .then(async (data) => {
                const { responseCode: { status }, response } = data;
                if (status.toLowerCase() == "success") {
                    await fetchTenantDetails();
                    setIsEditMode(false);
                } else {
                    console.log("Profile Details Update API Failed!");
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }

    const getUserProfileData = async () => {
        let params = { getProfile: userId };
        await dispatch(getUserProfileDetailsAction({ tenantId, authToken, userId, params, showLoader: false }))
            .then((data) => {
                const { responseCode: { status }, responseList } = data;
                if (isApiCallSuccess(status)) {
                    setUserProfileDetails(responseList[0]);
                } else {
                    console.log("User Profile Details not found!");
                }
            })
            .catch((error) => {
                console.error(error);
                setIsLoading(false);
            });
    }

    const getAccountDetails = async (advertiserId) => {
        let accountDetails;
        await dispatch(editAccountAction({ tenantId, authToken, userId, editId: advertiserId }))
            .then((data) => {
                const { responseCode: { status }, responseList } = data;
                if (status.toLowerCase() == "success") {
                    accountDetails = responseList[0];
                } else {
                    console.log("Tentative Amount Details Not Found!");
                }
            })
            .catch((error) => {
                console.error(error);
                setIsLoading(false);
            });
        return accountDetails;
    }

    const handleStatus = async (row, action) => {
        let accountDetails = await getAccountDetails(row.advertiserId);
        accountDetails.isActive = !accountDetails.isActive ? 1 : 0;
        await dispatch(addAccountAction(tenantId, authToken, userId, accountDetails, { action: 'update' }, row.advertiserId))
            .then((data) => {
                const {
                    responseCode: { status = "", msg = '' },
                } = data;
                if (status.toLowerCase() == "success") {
                    toast(status, msg);
                    setModalCallback(modalType.statusUpdated);
                } else {
                    toast(status, msg);
                }
            }).catch((error) => {
                console.error(error);
            });
    };

    const searchAdvertisers = async () => {
        if (isSearchInputFocused) {
            let params = { srch: searchParams };
            await dispatch(getProfileListAllAction({ tenantId, authToken, userId, params }))
                .then((data) => {
                    const {
                        responseCode: { status = "" },
                        response,
                    } = data;
                    if (status == "Success" && response && response.length > 0) {
                        let totalActiveCampaign = response.reduce((accumulator, currentValue) => {
                            return accumulator + currentValue.campaignCount
                        }, 0);
                        const mergedArray = response.map((data) => {
                            const matchingItem2 = balanceAll && balanceAll.find((item) => item.tenantId === data.advertiserId);
                            if (matchingItem2) {
                                // If a match is found, merge the data
                                return { ...data, ...matchingItem2 };
                            } else {
                                // If no match is found, return the original item from array1
                                return data;
                            }
                        });
                        setAccountList(mergedArray);
                        setAdvertiserDetails({ ...advertiserDetails, totalActiveCampaign });
                    } else {
                        console.log("Profile list in search not found");
                    }
                }).catch((error) => {
                    console.error(error);
                });
        }
    };

    const initialize = async () => {
        setIsLoading(true);
        await fetchAllAccountsBalance();
        await fetchTenantDetails();
        await fetchSubscriptionValidityDate();
        await fetchCurrentBalance();
        await fetchCurrentMonthDetails();
        await getUserProfileData();
        setIsLoading(false);
    }

    // const mapBalanceToAdvertisers = (list) => {
    //     console.log(list, 'ABC');
    //     console.log(balanceAll, 'ABC');
    //     const mergedArray = list.map((data) => {
    //         const matchingItem2 = balanceAll && balanceAll.find((item) => item.tenantId == data.advertiserId);
    //         if (matchingItem2) {
    //             // If a match is found, merge the data
    //             return { ...data, ...matchingItem2 };
    //         } else {
    //             // If no match is found, return the original item from array1
    //             return data;
    //         }
    //     }
    //     );
    //     console.log(mergedArray, 'MERGED ARRAY');
    //     setAccountList(mergedArray);
    // };

    useEffect(() => {
        let isAuthenticated = JSON.parse(localStorage.getItem('AuthData'));
        if (isEmpty(isAuthenticated)) {
            const { history } = props;
            history.push(routes.preSignIn);
        }
    }, []);

    useEffect(() => {
        if (targetTimeZone) {
            const { history } = props;
            let optionsList = checkTablePermission({ add: PERMISSION.ADMIN.PROFILE.ADD, edit: PERMISSION.ADMIN.PROFILE.EDIT, view: PERMISSION.ADMIN.PROFILE.VIEW }, cloneDeep(optionsForTable));
            let isTenantTypeAdvertiser = isTenantAdvertiser(tenantId);
            optionsList.columns.forEach((dataCol, index) => {
                if (dataCol.name == "updateOn") {
                    optionsList.columns[index].component = (row) => row.updateOn ? moment(getDateFromUtcToSpecificZone({ date: row.updateOn, targetTimeZone: targetTimeZone })).format("DD MMM, YYYY") : '-'
                }
            })

            setOptionsList(optionsList);
            setIsTenantTypeAdvertiser(isTenantTypeAdvertiser);
            // let redirectToConnection = localStorage.getItem('redirectToConnection');
            // if (redirectToConnection) {
            //     history.push(routes.admin.connection.name);
            //     localStorage.removeItem('redirectToConnection');
            // }
        }
    }, [targetTimeZone]);

    useEffect(() => {
        initialize();
    }, []);


    // SEARCH
    useEffect(() => {
        if (searchParams && searchParams.length > 3) {
            clearTimeout(searchTimeout);
            setSearchTimeout(setTimeout(() => searchAdvertisers(), 300));
        } else if (searchParams == '' && isSearchInputFocused) {
            searchAdvertisers();
        }
    }, [searchParams]);

    const detailCardValues = {
        options: [
            { label: 'Account Name :', value: tenantDetails.tenantName, edit: false, formKey: '', show: true },
            { label: 'Country :', value: tenantDetails.contact.country, edit: false, formKey: '', show: true },
            { label: 'Currency :', value: tenantCurrency && tenantCurrency.value, edit: false, formKey: '', show: true },
            { label: 'Organization Name:', value: tenantDetails.contact.organizationTitle, edit: true, formKey: formFields.organizationTitle.key, show: true },
            { label: 'Contact Name:', value: tenantDetails.contactPerson, edit: true, formKey: formFields.contactPerson.key, show: true },
            { label: 'Contact Number:', value: tenantDetails.contact.contactPhone, edit: true, formKey: formFields.contactPhone.key, show: true },
            { label: 'Contact Email:', value: tenantDetails.contactEmail, edit: true, formKey: formFields.contactEmail.key, show: true },
            { label: 'Billing Address:', value: tenantDetails.contact.address1, edit: true, formKey: formFields.address1.key, show: true },
            { label: 'Tax ID No.:', value: tenantDetails.contact.gst, edit: true, formKey: formFields.gst.key, show: true },
            { label: 'Registered Advertisers :', value: accountsList.length, edit: false, formKey: '', show: isTenantAgencyType },
            // { label: 'Available Connections :', value: tenantDetails.contact.gst, edit: false, formKey: '' },
            { label: 'Total Active Campaigns :', value: advertiserDetails.totalActiveCampaign, formFields: formFields, show: true, edit: false, link: `/${routes.mainRoute}/${routes.containers.dashboard}` },
            { label: 'Subscription Valid Till :', value: validityDate ? moment(getDateFromUtcToSpecificZone({ date: validityDate, targetTimeZone: targetTimeZone })).format("DD MMM, YYYY") : validityDate, show: true, edit: false, formKey: '', link: `/${routes.mainRoute}/${routes.containers.payment}/${routes.payment.subscription.name}` },
            { label: 'Credit / Wallet Bal:', value: `${currentBalance} ${tenantCurrency && tenantCurrency.value ? tenantCurrency.value : ''}`, show: true, edit: false, formKey: '', link: `/${routes.mainRoute}/${routes.containers.payment}/${routes.payment.billingHistory.name}` },
            { label: 'Current months tentative Invoice Amt:', value: advertiserDetails.tentativeAmountDetail, edit: false, formKey: '', show: true, link: `/${routes.mainRoute}/${routes.containers.payment}/${routes.payment.invoice.name}` }
        ]
    };

    return (
        <>
            {isLoading && <Spinner />}
            {modalConfirmation.confirmationOpen && (<ModalConfirmation
                open={modalConfirmation.confirmationOpen}
                onClose={toggleModal}
                confirmationInfo={modalConfirmation.confirmationInfo}
                handelConfirmationMessage={confirmationCallBack}
            />)}
            {
                toastModal.enableToast && <ToastModal
                    enableToast={toastModal.enableToast}
                    status={toastModal.toastStatus}
                    msg={toastModal.toastMsg}
                    // path={routes.containers.dataConfig + '/' + routes.dataConfig.variables.name}
                    idProps={props}
                    handleConfirmation={confirmationCallbackModel}
                    handleToastStatus={handleToastStatus}
                    confirmationMsg={toastModal.toastMsg}
                    poc={true}
                    outSideClickEnable={false}
                />
            }

            <div className="main-panel ion form__style">
                <div className="content-wrapper">
                    <BreadCrumb />
                    <div className="row mt-3 px-2">
                        {/* <div className="mb-3 isTenantAdvertisertabs-admin"> */}
                        <Tabs container="admin" tenantId={tenantId} />
                        {/* </div> */}

                        <div className="col-md-12 grid-margin">
                            <div className="card">
                                <div>
                                    <div className="p-4 pb-5">
                                        {/* Card Div  */}
                                        <div className='row mx-0 mt-4' style={{ backgroundColor: '#F7F8FC', border: "1px solid #C4CCD8", borderRadius: "10px 10px 0 0 " }}>
                                            <div className='col-md-6 d-flex py-3'>
                                                <div style={{ width: '40px', height: '40px' }}>
                                                    {
                                                        userProfileDetails.hasOwnProperty('profilePic') ?
                                                            <img style={{ width: '100%', height: '100%' }} className="img-fluid rounded-circle" src={userProfileDetails['profilePic']} alt="profile" />
                                                            :
                                                            <img className="img-fluid rounded-circle" src={placeholder} alt="profile" />
                                                    }
                                                </div>
                                                <div className='px-3'>
                                                    <h5 className="m-0" style={{ color: "#040B1B", fontSize: 14 }}>{tenantDetails.tenantName}</h5>
                                                    <div className='d-flex'>
                                                        <p className="m-0">Email: <span style={{ color: '#394256' }}>{tenantDetails.contactEmail}</span></p>
                                                        {
                                                            tenantDetails.contact.contactPhone &&
                                                            <p className="px-1"><span style={{ color: '#394256' }}>|</span> Contact Number: <span style={{ color: '#394256' }}>{tenantDetails.contact.contactPhone}</span></p>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-md-6 d-flex justify-content-end align-items-center'>
                                                {
                                                    isEditMode ?
                                                        <>
                                                            <button onClick={() => setIsEditMode(false)} className="btn mx-3" style={{ borderRadius: '0.5rem', border: '1px solid #DCE3EE', background: '#FFF', padding: '0.625rem 1.125rem' }}>
                                                                <span className="text-primary">Cancel</span>
                                                            </button>

                                                            <button onClick={() => {
                                                                setToastModal({
                                                                    enableToast: true,
                                                                    confirmationMsg: "Shall we proceed with updating your profile details?",
                                                                    toastMsg: "Shall we proceed with updating your profile details?",
                                                                    toastStatus: "save"
                                                                });
                                                            }} className="btn rounded-2" style={{ backgroundColor: '#383890', padding: '0.625rem 1.125rem' }}>
                                                                <span className="text-white">Save</span>
                                                            </button>
                                                        </>
                                                        :
                                                        checkPermission({ permissions: [PERMISSION.ADMIN.PROFILE.EDIT] }) &&
                                                        <button onClick={() => setIsEditMode(true)} className="btn text-primary">
                                                            <i style={{ fontSize: 18 }} className='ti ti-pencil' />
                                                            <span style={{ fontSize: 16 }}>Edit</span>
                                                        </button>
                                                }
                                            </div>
                                        </div>

                                        <div className="px-3" style={{ border: "1px solid #C4CCD8", borderTop: 'unset', borderRadius: " 0 0 10px 10px ", padding: 'inherit' }}>
                                            <div className='row'>
                                                {
                                                    detailCardValues.options.map((item, index) => {
                                                        return (
                                                            <DetailCard key={index} item={item} check={item.check} formFields={formFields} form={form} setForm={setForm} errors={setErrors} setErrors={setErrors} touched={touched} setTouched={setTouched} isEditMode={isEditMode} submited={submited} />
                                                        )
                                                    })
                                                }
                                            </div>
                                        </div>
                                    </div>

                                    <div style={{ width: '100%', height: '100%', border: '1px #C4CCD8 solid' }}></div>

                                    {
                                        isTenantAgency(tenantId) ?
                                            <div className="py-4">
                                                <h5 className="px-4 pt-2 font-weight-bold">Add Sub Advertiser / Agency</h5>
                                                <div className='d-flex align-items-center justify-content-between pt-2 position-relative'>
                                                    <div className='d-flex align-items-center mt-2 ml-4 search-adj'>
                                                        <i style={{ color: "#A4ABB5", fontSize: 12, }} className='ti ti-search ti-sm'></i>
                                                        <Input
                                                            onChange={handleChange}
                                                            onBlur={handleTouch}
                                                            value={form[formFields.search.key]}
                                                            setting={formFields[formFields.search.key]}
                                                            error={errors[formFields.search.key]}
                                                            submited={submited}
                                                            // disabled={true}
                                                            touched={touched[formFields.search.key]} />
                                                    </div>

                                                    {
                                                        checkPermission({
                                                            permissions: [PERMISSION.ADMIN.PROFILE.ADD]
                                                        }) && tenantId >= 0 && !isTenantAdvertiser(tenantId) &&
                                                        <Link
                                                            to={`/${routes.mainRoute}/${routes.containers.admin}/${routes.admin.account.name}/${routes.admin.account.add}`}
                                                            className='text-white text-decoration-none btn btn-primary mx-4'
                                                            style={{ height: 35, border: "1px solid #303890", color: "#303890", background: "#fff", marginBottom: 10, borderRadius: 6 }}
                                                        >
                                                            Add Advertiser
                                                        </Link>
                                                    }
                                                </div>

                                                <div style={{ padding: '0.5rem 1.5rem' }}>
                                                    <div className='campaign-adj'>
                                                        <div className="campaign-list-adj table-responsive">
                                                            {
                                                                isTenantTypeAdvertiser == false ?
                                                                    <Table
                                                                        options={optionsList}
                                                                        data={accountsList || []}
                                                                        handelAction={handleAction}
                                                                    />
                                                                    :
                                                                    ''
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            :
                                            null
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default withRouter(Account);
